/* ============================================================
   STOLZES UNIVERSE — Y2K behaviour
   Sparkle cursor, draggable popups, hit counter, guestbook,
   three arcade games, holo card tilt, and a lighter that lights.
   No dependencies. Everything degrades if its element is absent.
   ============================================================ */
(function () {
  'use strict';

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const rand = (a, b) => a + Math.random() * (b - a);
  const pick = a => a[(Math.random() * a.length) | 0];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- sparkle cursor trail ---------- */
  const coarse = window.matchMedia('(hover: none)').matches;
  const small = () => innerWidth < 640;

  function sparkleTrail() {
    // On touch, pointermove fires all through a scroll — that carpets the DOM
    // with sparkles and makes the page feel sticky. Pointer trail is a mouse joy.
    if (reduced || coarse) return;
    const glyphs = ['✦', '✧', '★', '˚', '✩', '·'];
    const colors = ['#ff1493', '#00ffff', '#ffe566', '#b6ff00', '#8a2be2'];
    let last = 0;
    addEventListener('pointermove', e => {
      const now = performance.now();
      if (now - last < 42) return;       // throttle so we don't carpet the DOM
      last = now;
      const s = document.createElement('span');
      s.className = 'sparkle-dot';
      s.textContent = pick(glyphs);
      s.style.color = pick(colors);
      s.style.left = (e.clientX + rand(-6, 6)) + 'px';
      s.style.top  = (e.clientY + rand(-6, 6)) + 'px';
      document.body.appendChild(s);
      setTimeout(() => s.remove(), 700);
    }, { passive: true });
  }

  /* ---------- hit counter ---------- */
  function hitCounter() {
    const el = $('[data-counter]');
    if (!el) return;
    const KEY = 'stolzes_hits';
    // Seed somewhere plausible for a site that's "been up since 2003".
    let n = parseInt(localStorage.getItem(KEY) || '0', 10);
    if (!n) n = 141_022 + ((Math.random() * 900) | 0);
    n += 1;
    localStorage.setItem(KEY, String(n));
    el.innerHTML = String(n).padStart(7, '0').split('').map(d => `<span>${d}</span>`).join('');
  }

  /* ---------- popup windows ---------- */
  function makePopup({ title, html, x, y, life }) {
    const p = document.createElement('div');
    p.className = 'popup';
    p.style.left = (x ?? rand(20, Math.max(40, innerWidth - 360))) + 'px';
    p.style.top  = (y ?? rand(60, Math.max(80, innerHeight - 240))) + 'px';
    p.innerHTML =
      `<div class="popup__bar"><span>${title}</span><button class="popup__x" aria-label="Close">×</button></div>` +
      `<div class="popup__body">${html}</div>`;
    document.body.appendChild(p);

    p.querySelector('.popup__x').addEventListener('click', () => p.remove());

    // drag by the title bar
    const bar = p.querySelector('.popup__bar');
    let dx = 0, dy = 0, dragging = false;
    bar.addEventListener('pointerdown', e => {
      dragging = true; dx = e.clientX - p.offsetLeft; dy = e.clientY - p.offsetTop;
      bar.setPointerCapture(e.pointerId);
    });
    bar.addEventListener('pointermove', e => {
      if (!dragging) return;
      p.style.left = Math.max(0, Math.min(innerWidth - 60, e.clientX - dx)) + 'px';
      p.style.top  = Math.max(0, Math.min(innerHeight - 40, e.clientY - dy)) + 'px';
    });
    bar.addEventListener('pointerup', e => { dragging = false; bar.releasePointerCapture(e.pointerId); });

    if (life) setTimeout(() => p.remove(), life);
    return p;
  }

  function welcomePopups() {
    if (sessionStorage.getItem('stolzes_welcomed')) return;
    sessionStorage.setItem('stolzes_welcomed', '1');
    // Park them in the margins — the joke lands better when you can still see
    // the thing they're covering up. On a phone there is no margin to park in,
    // so it's one popup, near the bottom, and it dismisses itself.
    setTimeout(() => makePopup({
      title: '★ WELCOME.EXE',
      x: small() ? 10 : 16,
      y: small() ? Math.max(60, innerHeight - 250) : Math.max(80, innerHeight - 300),
      life: small() ? 11000 : null,
      html: `<p style="margin:0 0 8px"><b>Hello websurfer!!</b></p>
             <p style="margin:0 0 10px">You have entered <b>STOLZES UNIVERSE</b>. Please remove your wallet chain before sitting on the inflatable furniture.</p>
             <p style="margin:0" class="tiny mono">Best viewed at 1024×768 in Netscape Navigator.</p>`,
    }), 1800);

    if (small()) return;

    setTimeout(() => makePopup({
      title: 'CONGRATULATIONS!!!',
      x: Math.max(16, innerWidth - 360), y: 90,
      html: `<p style="margin:0 0 8px">You are the <b class="blink">1,000,000th</b> visitor!</p>
             <p style="margin:0 0 10px">You have won a complimentary slice of cake.*</p>
             <p style="margin:0" class="tiny">*Cake is virtual. Cake is a lie. Cake is downstairs.</p>`,
    }), 9000);
  }

  /* ---------- the lighter ---------- */
  function lighter() {
    const stage = $('[data-lighter]');
    if (!stage) return;

    let sparkTimer = null;
    const spark = () => {
      const s = document.createElement('i');
      s.className = 'spark';
      s.style.left = (stage.clientWidth / 2 + rand(-14, 14)) + 'px';
      s.style.top  = (stage.clientHeight * 0.26) + 'px';
      s.style.setProperty('--dx', rand(-40, 40) + 'px');
      s.style.background = pick(['#ffe566', '#ff8c00', '#fff']);
      stage.appendChild(s);
      setTimeout(() => s.remove(), 900);
    };

    const light = () => {
      stage.classList.add('is-lit');
      if (!reduced && !sparkTimer) sparkTimer = setInterval(spark, 190);
    };
    const snuff = () => {
      stage.classList.remove('is-lit');
      clearInterval(sparkTimer); sparkTimer = null;
    };

    stage.addEventListener('pointerenter', light);
    stage.addEventListener('pointerleave', snuff);
    stage.addEventListener('focus', light);
    stage.addEventListener('blur', snuff);
    // Touch has no hover, so tap toggles.
    stage.addEventListener('click', e => {
      if (e.pointerType === 'touch' || matchMedia('(hover: none)').matches) {
        e.preventDefault();
        stage.classList.contains('is-lit') ? snuff() : light();
      }
    });
  }

  /* ---------- holographic card ---------- */
  function holoCard() {
    const wrap = $('[data-holo]');
    if (!wrap) return;
    const inner = wrap.querySelector('.holo__inner');
    const shine = wrap.querySelector('.holo__shine');
    wrap.addEventListener('pointermove', e => {
      const r = wrap.getBoundingClientRect();
      const px = (e.clientX - r.left) / r.width;
      const py = (e.clientY - r.top) / r.height;
      inner.style.transform = `rotateY(${(px - .5) * 26}deg) rotateX(${(.5 - py) * 26}deg)`;
      if (shine) shine.style.backgroundPosition = `${px * 100}% ${py * 100}%`;
    });
    wrap.addEventListener('pointerleave', () => {
      inner.style.transform = 'rotateY(0) rotateX(0)';
    });
  }

  /* ---------- lightbox ---------- */
  function lightbox() {
    // Skip the Instagram tiles — those are links out to the profile.
    const imgs = $$('.collage:not(.collage--ig) img');
    if (!imgs.length) return;

    const open = img => {
      const box = document.createElement('div');
      box.className = 'lightbox';
      box.innerHTML =
        `<button class="lightbox__x" aria-label="Close">✕</button>
         <div><img src="${img.currentSrc || img.src}" alt="${(img.alt || '').replace(/"/g, '&quot;')}">
         <div class="lightbox__cap">${img.alt || ''}</div></div>`;
      const close = () => { box.remove(); removeEventListener('keydown', onKey); };
      const onKey = e => { if (e.key === 'Escape') close(); };
      box.addEventListener('click', close);
      addEventListener('keydown', onKey);
      document.body.appendChild(box);
    };

    imgs.forEach(img => {
      img.addEventListener('click', e => { e.preventDefault(); open(img); });
    });
  }

  /* ---------- the celebration ----------
     Book swings open, the cake lighter springs out of it lit, sprinkles
     everywhere, SIGNED stamp lands on top. Uses the real product cut-out so
     it belongs to the rest of the site. */
  function celebrate(lighterSrc, flameSrc) {
    const wrap = document.createElement('div');
    wrap.className = 'celebrate';
    wrap.innerHTML = `
      <div class="celebrate__stage">
        <div class="stamp">SIGNED ♥</div>
        <div class="book">
          <div class="book__page"><div class="book__ruled"></div></div>
          <div class="book__cover">GUESTBOOK</div>
        </div>
        <div class="cakepop">
          <img src="${flameSrc}" class="cakepop__flame" alt="">
          <img src="${lighterSrc}" class="cakepop__body" alt="">
        </div>
      </div>`;
    document.body.appendChild(wrap);

    const stage = wrap.querySelector('.celebrate__stage');
    if (!reduced) {
      const colors = ['#ff1493', '#00ffff', '#ffe566', '#b6ff00', '#8a2be2', '#e3122b', '#ff69b4'];
      for (let i = 0; i < 46; i++) {
        const s = document.createElement('i');
        s.className = 'sprinkle';
        const angle = rand(0, Math.PI * 2), dist = rand(90, 260);
        s.style.background = pick(colors);
        s.style.setProperty('--sx', Math.cos(angle) * dist + 'px');
        s.style.setProperty('--sy', Math.sin(angle) * dist + 'px');
        s.style.setProperty('--sr', rand(-540, 540) + 'deg');
        s.style.animationDelay = rand(0.45, 0.8) + 's';
        stage.appendChild(s);
      }
    }

    // Let the overlay paint before flipping the open state, or the transition
    // has nothing to animate from.
    requestAnimationFrame(() => requestAnimationFrame(() => wrap.classList.add('is-open')));

    const dismiss = () => {
      wrap.classList.add('is-leaving');
      setTimeout(() => wrap.remove(), 500);
    };
    setTimeout(dismiss, reduced ? 2200 : 4200);
    wrap.style.pointerEvents = 'auto';
    wrap.addEventListener('click', dismiss);
  }

  /* ---------- guestbook ---------- */
  const FORTUNES = [
    'your next cake will be structurally sound.',
    'a cherry will fall in your favour this week.',
    'you will be offered fondant. decline politely.',
    'someone will ask if it is real. say nothing.',
    'the buttercream forecast is: excellent.',
    'you will find a sprinkle in your pocket on tuesday.',
    'beware of anyone who says they are "doing a cleanse".',
    'today is a good day to light something (a candle).',
  ];

  function guestbook() {
    const form = $('[data-guestbook]');
    if (!form) return;
    const list = $('[data-guestbook-list]');
    const countEl = $('[data-guestbook-count]');
    const KEY = 'stolzes_guestbook';
    const seed = [
      { n: 'xXcherry_bombXx', m: 'ur site is SO fire literally (the lighter LOL)', d: '29.07.2026', f: FORTUNES[0] },
      { n: 'DJ Sahnehäubchen', m: 'came for the cake stayed for the iPod. 10/10', d: '28.07.2026', f: FORTUNES[4] },
      { n: 'anonymous_wien', m: 'is the torte real or is the torte a concept?? asking 4 me', d: '27.07.2026', f: FORTUNES[3] },
    ];

    const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };

    let freshKey = null;
    const render = () => {
      const mine = read();
      const all = [...mine, ...seed];
      list.innerHTML = all.map(e => {
        const isNew = freshKey && `${e.n}|${e.m}` === freshKey;
        return `<div class="gb-entry${isNew ? ' is-new' : ''}">
          <b>${esc(e.n)}</b> <span class="tiny mono">${esc(e.d)}</span>${isNew ? '<span class="gb-new-tag">NEW!</span>' : ''}
          <br>${esc(e.m)}
          ${e.f ? `<span class="gb-fortune">🍒 your cake fortune: ${esc(e.f)}</span>` : ''}
        </div>`;
      }).join('');
      if (countEl) countEl.textContent = all.length;
    };

    form.addEventListener('submit', e => {
      e.preventDefault();
      const n = form.querySelector('[name=gbname]').value.trim() || 'anonymous surfer';
      const m = form.querySelector('[name=gbmsg]').value.trim();
      if (!m) {
        form.querySelector('[name=gbmsg]').focus();
        return;
      }
      const entry = { n, m, d: new Date().toLocaleDateString('de-AT'), f: pick(FORTUNES) };
      localStorage.setItem(KEY, JSON.stringify([entry, ...read()].slice(0, 40)));
      form.reset();
      freshKey = `${n}|${m}`;
      render();

      celebrate(form.dataset.lighter, form.dataset.flame);
      setTimeout(() => { freshKey = null; render(); }, 20000);
    });

    render();
  }

  /* ---------- game 1: CHERRY CATCH ---------- */
  function cherryCatch() {
    const c = $('#game-cherry');
    if (!c) return;
    const ctx = c.getContext('2d');
    const W = c.width, H = c.height;
    let plateX = W / 2, score = 0, lives = 3, drops = [], running = false, t = 0;
    const out = $('#game-cherry-score');

    const reset = () => { score = 0; lives = 3; drops = []; t = 0; running = true; };

    c.addEventListener('pointermove', e => {
      const r = c.getBoundingClientRect();
      plateX = (e.clientX - r.left) * (W / r.width);
    });
    c.addEventListener('click', () => { if (!running) reset(); });

    function step() {
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H);

      if (running) {
        t++;
        if (t % 34 === 0) drops.push({ x: rand(14, W - 14), y: -10, v: rand(1.5, 3.2) });
        drops.forEach(d => { d.y += d.v; });

        drops = drops.filter(d => {
          if (d.y > H - 26 && Math.abs(d.x - plateX) < 30) { score++; return false; }
          if (d.y > H) { lives--; return false; }
          return true;
        });
        if (lives <= 0) running = false;
      }

      // cherries
      drops.forEach(d => {
        ctx.fillStyle = '#e3122b';
        ctx.beginPath(); ctx.arc(d.x, d.y, 7, 0, 7); ctx.fill();
        ctx.strokeStyle = '#b6ff00'; ctx.lineWidth = 2;
        ctx.beginPath(); ctx.moveTo(d.x, d.y - 6); ctx.quadraticCurveTo(d.x + 7, d.y - 16, d.x + 2, d.y - 20); ctx.stroke();
      });

      // the plate of cake
      ctx.fillStyle = '#fff7e8';
      ctx.fillRect(plateX - 30, H - 20, 60, 12);
      ctx.fillStyle = '#ff69b4';
      ctx.fillRect(plateX - 30, H - 24, 60, 5);

      ctx.fillStyle = '#b6ff00'; ctx.font = '12px "Courier New", monospace';
      ctx.fillText('SCORE ' + score, 6, 14);
      ctx.fillText('♥'.repeat(Math.max(0, lives)), W - 46, 14);

      if (!running) {
        ctx.fillStyle = '#ffe566'; ctx.font = '14px "Courier New", monospace';
        ctx.textAlign = 'center';
        ctx.fillText(score ? 'GAME OVER' : 'CLICK TO PLAY', W / 2, H / 2 - 6);
        ctx.fillText(score ? 'click to retry' : 'catch the cherries', W / 2, H / 2 + 12);
        ctx.textAlign = 'left';
      }
      if (out) out.textContent = 'high score: ' + Math.max(score, +(localStorage.getItem('stolzes_cherry') || 0));
      if (score > +(localStorage.getItem('stolzes_cherry') || 0)) localStorage.setItem('stolzes_cherry', score);

      requestAnimationFrame(step);
    }
    step();
  }

  /* ---------- game 2: CAKE CLICKER ---------- */
  function cakeClicker() {
    const btn = $('#game-clicker');
    if (!btn) return;
    const out = $('#game-clicker-score');
    const KEY = 'stolzes_clicks';
    let n = +(localStorage.getItem(KEY) || 0);
    const GOAL = 50;

    const paint = () => {
      out.innerHTML = n >= GOAL
        ? `${n} slices — code <b style="color:#ffe566">SUGARCRASH</b> unlocked`
        : `${n} / ${GOAL} slices to unlock a secret`;
    };

    btn.addEventListener('click', e => {
      n++; localStorage.setItem(KEY, n); paint();
      const s = document.createElement('span');
      s.className = 'sparkle-dot';
      s.textContent = pick(['🍒', '✦', '🍰']);
      s.style.left = e.clientX + 'px'; s.style.top = e.clientY + 'px';
      document.body.appendChild(s); setTimeout(() => s.remove(), 700);
      btn.style.transform = `scale(${1 + Math.sin(n) * .05}) rotate(${rand(-6, 6)}deg)`;
      if (n === GOAL) makePopup({
        title: 'ACHIEVEMENT.DLL',
        html: `<p style="margin:0 0 8px">50 slices!! You are officially <b>sugar-crashed</b>.</p>
               <p style="margin:0">Discount code: <b class="rainbow">SUGARCRASH</b></p>`,
      });
    });
    paint();
  }

  /* ---------- game 3: KEEP IT LIT ---------- */
  function keepItLit() {
    const c = $('#game-flame');
    if (!c) return;
    const ctx = c.getContext('2d');
    const W = c.width, H = c.height;
    let fuel = 60, held = false, seconds = 0, running = false, gust = 0, last = performance.now();
    const out = $('#game-flame-score');

    const down = e => { e.preventDefault(); held = true; if (!running) { running = true; fuel = 60; seconds = 0; } };
    const up = () => { held = false; };
    c.addEventListener('pointerdown', down);
    addEventListener('pointerup', up);
    addEventListener('keydown', e => { if (e.code === 'Space' && document.activeElement === c) down(e); });
    addEventListener('keyup', e => { if (e.code === 'Space') up(); });

    function step(now) {
      const dt = Math.min(0.05, (now - last) / 1000); last = now;
      ctx.fillStyle = '#000'; ctx.fillRect(0, 0, W, H);

      if (running) {
        seconds += dt;
        gust = Math.max(0, gust - dt);
        if (Math.random() < 0.006) gust = rand(.5, 1.2);          // a draft
        fuel += (held ? 26 : -20) * dt - gust * 34 * dt;
        if (fuel > 100) { fuel = 100; running = false; }           // flooded it
        if (fuel <= 0) { fuel = 0; running = false; }              // went out
      }

      // flame
      const h = 10 + fuel * 0.8;
      const g = ctx.createLinearGradient(0, H - 30 - h, 0, H - 30);
      g.addColorStop(0, '#fff'); g.addColorStop(.4, '#ffe566'); g.addColorStop(1, '#ff8c00');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(W / 2, H - 30 - h);
      ctx.quadraticCurveTo(W / 2 + 16 + gust * 20, H - 30 - h / 2, W / 2, H - 30);
      ctx.quadraticCurveTo(W / 2 - 16 + gust * 20, H - 30 - h / 2, W / 2, H - 30 - h);
      ctx.fill();

      // lighter body
      ctx.fillStyle = '#fff7e8'; ctx.fillRect(W / 2 - 13, H - 30, 26, 26);
      ctx.fillStyle = '#ff69b4';
      for (let i = 0; i < 7; i++) ctx.fillRect(W / 2 - 10 + (i * 7) % 22, H - 26 + (i * 5) % 18, 3, 3);

      // fuel gauge
      ctx.fillStyle = '#333'; ctx.fillRect(8, 8, W - 16, 8);
      ctx.fillStyle = fuel > 85 ? '#ff1493' : '#b6ff00';
      ctx.fillRect(8, 8, (W - 16) * fuel / 100, 8);

      ctx.fillStyle = '#b6ff00'; ctx.font = '12px "Courier New", monospace';
      ctx.fillText(seconds.toFixed(1) + 's', 8, 32);

      if (!running) {
        ctx.fillStyle = '#ffe566'; ctx.font = '13px "Courier New", monospace'; ctx.textAlign = 'center';
        ctx.fillText(seconds ? (fuel >= 100 ? 'TOO MUCH!' : 'IT WENT OUT') : 'HOLD TO LIGHT', W / 2, 56);
        if (seconds) ctx.fillText('lasted ' + seconds.toFixed(1) + 's', W / 2, 72);
        ctx.textAlign = 'left';
        const best = +(localStorage.getItem('stolzes_flame') || 0);
        if (seconds > best) localStorage.setItem('stolzes_flame', seconds.toFixed(1));
      }
      if (out) out.textContent = 'best: ' + (localStorage.getItem('stolzes_flame') || '0.0') + 's';
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- refreshments picker ---------- */
  function refreshments() {
    $$('[data-treat]').forEach(btn => {
      btn.addEventListener('click', () => {
        makePopup({
          title: 'room_service.exe',
          html: `<p style="margin:0 0 8px">${btn.dataset.treat}</p>
                 <p style="margin:0" class="tiny mono">Health bar replenished. You may now continue surfing.</p>`,
          life: 9000,
        });
      });
    });
  }

  /* ---------- "just show me the cake" ---------- */
  function peek() {
    const btn = $('[data-peek]');
    const form = $('[data-guestbook]');
    if (!btn || !form) return;
    btn.addEventListener('click', () => celebrate(form.dataset.lighter, form.dataset.flame));
  }

  /* ---------- gag button ---------- */
  function doNotClick() {
    const b = $('[data-donotclick]');
    if (!b) return;
    let n = 0;
    b.addEventListener('click', () => {
      n++;
      const lines = [
        'I told you not to click here.',
        'Seriously. Stop.',
        'This is the third time.',
        'Fine. Here is a cherry. 🍒',
        'There is nothing else here. Go buy a lighter.',
      ];
      makePopup({ title: 'ERROR', html: `<p style="margin:0">${lines[Math.min(n - 1, lines.length - 1)]}</p>`, life: 5000 });
    });
  }

  /* ---------- konami ---------- */
  function konami() {
    const seq = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
    let i = 0;
    addEventListener('keydown', e => {
      i = (e.key === seq[i] || e.key.toLowerCase() === seq[i]) ? i + 1 : 0;
      if (i === seq.length) {
        i = 0;
        document.body.style.transition = 'filter 1s';
        document.body.style.filter = 'hue-rotate(180deg) saturate(2)';
        makePopup({ title: 'CHEAT ACTIVATED', html: '<p style="margin:0">🍒 <b>SUGAR RUSH MODE</b> 🍒<br>Press again to calm down.</p>', life: 8000 });
        setTimeout(() => { document.body.style.filter = ''; }, 8000);
      }
    });
  }

  /* ---------- boot ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    sparkleTrail(); hitCounter(); welcomePopups(); lighter(); holoCard();
    lightbox(); guestbook(); peek(); cherryCatch(); cakeClicker(); keepItLit();
    refreshments(); doNotClick(); konami();
  });
})();
